export default __webpack_public_path__ + "static/media/W.eb6cb2df.svg";